<style lang="scss">
  @import '../resources/scss/new_individual_details.scss';
</style>

<script lang="ts">
  import NewThumbnailProjectNameDate from '../components/New_Thumbnail_Project_Name_Date.svelte'
  import ArrowRight from '../components/svgs/ArrowRight.svelte'
  import { documentInnerNewsItems, authData, newsPagination } from '../stores/stores'
  import { useParams } from 'svelte-navigator'
  import { fetchNewsLabels, getNewsFromApi } from '../controllers/NewsController'
  import { apiLogin } from '../controllers/AuthController'
  import type {
    DocumentListStructureItemsInner,
    Translations
  } from '../api/rest/backoffice-data/generated'
  import { locale } from 'svelte-i18n'
  import { Constants } from '../config/constants'
  import { isNumber } from '../helpers/ValidationHelper'
  import Skeleton from '../../node_modules/svelte-skeleton-loader/src/Skeleton.svelte'
  import CustomSkeleton from '../components/CustomSkeleton.svelte'
  import { routes, newsLabels } from '../stores/stores'
  import { Slugs } from '../config/slugs'
  import { navigate } from 'svelte-navigator'
  import { fallbackLocale } from '../services/i18n'

  let isLoaded = false
  let newObj: DocumentListStructureItemsInner | undefined
  let newTranslations: Translations | undefined
  let parsedImage: any
  let lang = $locale ?? fallbackLocale
  const params = useParams()

  if ($params.id && !isNumber($params.id)) {
    window.location.href = $routes.get(lang + Constants.DOUBLE_BARS + Slugs.News)!
  }

  void fetchNewsLabels(lang).then(() => {
    void apiLogin().then(() => {
      void getNewsFromApi(lang, $authData).then(() => {
        newObj = $documentInnerNewsItems.find(d => d.id === Number($params.id))
        newTranslations = newObj?.translations?.pop()
        isLoaded = true
        parsedImage = newObj ? JSON.parse(JSON.stringify(newObj.resource!)) : null
      })
    })
  })
</script>

{#if isLoaded}
  <div class="new-thumbnail">
    <div class="container-xxl py-section">
      <div class="row">
        <div class="col-auto col-md-3 d-flex justify-content-end">
          <button
            class="button text-neutral-a read-more-btn d-flex justify-content-end back-btn"
            on:click={() => navigate(-1)}
            ><div class="stroke-svg"><ArrowRight /></div>
            {$newsLabels?.back}</button
          >
        </div>
        {#if newObj}
          <div class="col d-flex align-items-center">
            <NewThumbnailProjectNameDate publicationDate={newObj.publicationDate} />
          </div>
        {/if}
      </div>
      <div class="row">
        <div class="col-12 col-md-9 offset-md-3">
          {#if newObj}
            {#if parsedImage}
              <div
                class="new-image"
                style="background-image: url({parsedImage.featuredImage});"
              />
            {/if}
            {#if newTranslations}
              <div class="h2 mb-0 description">{newTranslations.title}</div>
              <div class="description">
                {@html newTranslations.body}
              </div>
            {/if}
          {/if}
        </div>
      </div>
    </div>
  </div>
{:else}
  <CustomSkeleton>
    <div class="skeleton-container" slot="skeleton-content">
      <div class="new-image image mb-2">
        <Skeleton />
      </div>
      <div class="container-xxl py-section">
        <div class="row">
          <div class="col-3" />
          <div class="col-9">
            <div class="row">
              <div class="col-12">
                <div class="title mb-3">
                  <Skeleton />
                </div>
                <div class="body description mb-3">
                  <Skeleton count={8} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CustomSkeleton>
{/if}
